/*
 * @Author: Dom
 * @Date: 2022-06-16 10:02:49
 * @LastEditTime: 2022-07-08 16:25:33
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\logistics\customer\service.ts
 */
import request from '@/utils/request';
import {TableListQueryParams, SaveFormDataType, IsDefaultAddressType,InfoParamsType} from './data.d'

//获取列表
export async function getPageList(params:TableListQueryParams) {
    return request({
        url: '/seller/v1/userAddress/getUserAddressPageList',
        method: 'POST',
        data: params
    })
}

//获取单条信息
export async function getInfo(params:InfoParamsType) {
    return request({
        url: '/seller/v1/userAddress/infoUserAddress',
        method: 'POST',
        data: params
    })
}

//保存地址
export async function save(params:SaveFormDataType) {
    return request({
        url: '/seller/v1/userAddress/saveUserAddress',
        method: 'POST',
        data: params
    })
}

//删除地址
export async function deleteFn(params:InfoParamsType) {
    return request({
        url: '/seller/v1/userAddress/deleteUserAddress',
        method: 'POST',
        data: params
    })
}

//更新地址
export async function updateUserAddress(params:SaveFormDataType) {
    return request({
        url: '/seller/v1/userAddress/updateUserAddress',
        method: 'POST',
        data: params
    })
}

//设置默认地址
export async function addressDefault(params:IsDefaultAddressType) {
    return request({
        url: '/seller/v1/userAddress/updateUserAddress',
        method: 'POST',
        data: params
    })
}
